export const liabilities = '*edit/liabilities*';
export const personalInformation = '*edit/personalInformation*';
export const familyInformation = '*edit/familyInformation*';
export const financialProfile = '*edit/financialProfile*';
export const investmentAssets = '*edit/investmentAssets*';
export const goals = '*edit/goals*';
export const ssiAndPensions = '*edit/ssiAndPensions*';
export const otherAdvisors = '*edit/OtherAdvisors*';
export const expense = '*edit/expense*';
export const additionalNotes = '*edit/additionalNotes*';
export const insurance = '*edit/insurance*';
export const estatePlanning = '*/edit/estatePlanning*';
export const incomeDetails = '*edit/incomeDetails*';
